import axios from "axios";
import { logout } from "../helper/authUtils.jsx";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // replace with your API base URL

// Global axios interceptor for token expiry handling
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      logout();
    }
    return Promise.reject(error);
  }
);


// API request function
export const apiRequest = async (
  endpoint,
  method,
  data = null,
  headers = {}
) => {
  // console.log(endpoint, API_BASE_URL);
  const url = `${API_BASE_URL}${endpoint}`;

  //   console.log(data);
  const options = {
    method: method,
    headers: {
      ...(data instanceof FormData
        ? {}
        : { "Content-Type": "application/json" }),
      ...headers,
    },
  };

  // Auto-add Authorization header if token exists
  const token = localStorage.getItem("token");
  if (token) {
    options.headers.Authorization = `Bearer ${token}`;
  }
  if (data) {

    options.data = data;
  }
  try {
    const response = await axios(url, options);

    if (!response) {
      throw new Error(`Error: ${response.status}`);
    }

    return response;
  } catch (error) {
    console.error("API request failed:", error);
    throw error;
  }
};

// Get Product Details by ID
export const getProductDetails = async (pid) => {
  return await apiRequest(`/Product/productdetails/${pid}`, "GET");
};


